"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.history = void 0;

var _reduxLogger = _interopRequireDefault(require("redux-logger"));

var _redux = require("redux");

var _connectedReactRouter = require("connected-react-router");

var _history = require("history");

var _reduxDevtoolsExtension = require("redux-devtools-extension");

var _reduxSaga = _interopRequireDefault(require("redux-saga"));

var _AppReducers = _interopRequireDefault(require("./AppReducers"));

var _AppSagas = _interopRequireDefault(require("./AppSagas"));

var _qs = _interopRequireDefault(require("qs"));

var _config = _interopRequireDefault(require("../../config"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // export const history = createHistory();


var history = (0, _history.createBrowserHistory)();
exports.history = history;

var appendQueryToLocation = function appendQueryToLocation() {
  history.location = Object.assign(history.location, // parse the search string using your package of choice
  {
    query: _qs["default"].parse(history.location.search, {
      ignoreQueryPrefix: true
    })
  });
};

appendQueryToLocation();
history.listen(function () {
  appendQueryToLocation();
}); // create the saga middleware

var sagaMiddleware = (0, _reduxSaga["default"])();
var appStore = null;

if (_config["default"].env === 'dev') {
  appStore = (0, _redux.createStore)((0, _AppReducers["default"])(history), (0, _reduxDevtoolsExtension.composeWithDevTools)((0, _redux.applyMiddleware)(_reduxLogger["default"], sagaMiddleware, (0, _connectedReactRouter.routerMiddleware)(history))));
} else {
  appStore = (0, _redux.createStore)((0, _AppReducers["default"])(history), (0, _redux.applyMiddleware)(sagaMiddleware, (0, _connectedReactRouter.routerMiddleware)(history)));
}

sagaMiddleware.run(_AppSagas["default"]);
var _default = appStore;
exports["default"] = _default;